import type { ImageProps as ImagePropsBase } from '@wix/design-system';
import { Image as ImageBase } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext } from './../../../../ricos-context';

import type { GalleryItem } from '../common-types';
import { getMediaSrc } from './utils';

type CarouselItemProps = ImagePropsBase & {
  galleryItem: GalleryItem;
};

export const CarouselItem: React.FC<CarouselItemProps> = ({ galleryItem, ...props }) => {
  const { environment } = useContext(RicosContext);

  const requiredHeight = 157;
  const requiredWidth = 252;

  return (
    <ImageBase
      fit="contain"
      src={getMediaSrc({ item: galleryItem, requiredWidth, requiredHeight })}
      borderRadius={environment === 'liveSite' ? 0 : undefined}
      height={requiredHeight}
      width={requiredWidth}
      {...props}
    />
  );
};
